import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-223d3446"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "d-flex justify-content-center align-items-center bg-light",
    style: { "height": "70vh" }
};
const _hoisted_2 = { class: "container col-md-4" };
const _hoisted_3 = { class: "card p-4" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "h4 mb-4 text-center" }, "Restablecer Contraseña", -1 /* HOISTED */));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-center mb-4" }, " Ingresa una nueva contraseña y confírmala para restablecer tu acceso. ", -1 /* HOISTED */));
const _hoisted_6 = { class: "mb-3" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "password",
    class: "form-label"
}, "Nueva Contraseña", -1 /* HOISTED */));
const _hoisted_8 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_9 = { class: "mb-3" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "confirmPassword",
    class: "form-label"
}, "Confirmar Contraseña", -1 /* HOISTED */));
const _hoisted_11 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_12 = { class: "d-grid gap-2" };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2",
    role: "status",
    "aria-hidden": "true"
};
const _hoisted_15 = { class: "text-center mt-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createCommentVNode(" Formulario de Restablecer Contraseña "),
                _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _hoisted_5,
                    _createElementVNode("form", {
                        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"]))
                    }, [
                        _createCommentVNode(" Nueva Contraseña "),
                        _createElementVNode("div", _hoisted_6, [
                            _hoisted_7,
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.password) = $event)),
                                type: "password",
                                id: "password",
                                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.passwordError }]),
                                placeholder: "Ingresa tu nueva contraseña",
                                required: ""
                            }, null, 2 /* CLASS */), [
                                [_vModelText, _ctx.password]
                            ]),
                            (_ctx.passwordError)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, " La contraseña debe tener al menos 8 caracteres, incluir una mayúscula, un número y un carácter especial. "))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createCommentVNode(" Confirmar Contraseña "),
                        _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.confirmPassword) = $event)),
                                type: "password",
                                id: "confirmPassword",
                                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.confirmPasswordError }]),
                                placeholder: "Confirma tu nueva contraseña",
                                required: ""
                            }, null, 2 /* CLASS */), [
                                [_vModelText, _ctx.confirmPassword]
                            ]),
                            (_ctx.confirmPasswordError)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Las contraseñas no coinciden. "))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createCommentVNode(" Botón de Restablecer Contraseña "),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn-primary",
                                disabled: _ctx.loading
                            }, [
                                (_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(" Restablecer Contraseña ")
                            ], 8 /* PROPS */, _hoisted_13)
                        ]),
                        _createCommentVNode(" Mensaje de Éxito o Error "),
                        (_ctx.message)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: _normalizeClass([
                                    'mt-3',
                                    _ctx.messageType === 'error' ? 'text-danger' : 'text-success',
                                    'text-center',
                                ])
                            }, _toDisplayString(_ctx.message), 3 /* TEXT, CLASS */))
                            : _createCommentVNode("v-if", true)
                    ], 32 /* NEED_HYDRATION */)
                ]),
                _createCommentVNode(" Enlace para regresar al inicio de sesión "),
                _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", null, [
                        _createTextVNode(" ¿Recuperaste tu contraseña? "),
                        _createVNode(_component_router_link, {
                            to: "/login",
                            class: "link-primary"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("Inicia sesión aquí")
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ])
            ])
        ])
    ], 64 /* STABLE_FRAGMENT */));
}
